var map = {
	"./16.png": 18,
	"./32.png": 19,
	"./48.png": 20,
	"./64.png": 21,
	"./favicon.ico": 22,
	"./favicon_114.png": 23,
	"./favicon_120.png": 24,
	"./favicon_144.png": 25,
	"./favicon_152.png": 26,
	"./favicon_167.png": 27,
	"./favicon_180.png": 28,
	"./favicon_57.png": 29,
	"./favicon_60.png": 30,
	"./favicon_72.png": 31,
	"./favicon_76.png": 32,
	"./favicon_fb.png": 33,
	"./windows_large.png": 34,
	"./windows_square.png": 35,
	"./windows_tiny.png": 36,
	"./windows_wide.png": 37
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;